// extracted by mini-css-extract-plugin
module.exports = {"root":"AcceptanceDetailView_root_1xKVp","inner":"AcceptanceDetailView_inner_q592l"};